<template>
  <div class="container-layout">
    <v-row no-gutters>
      <v-col
        :class="['col-xs-12', `col-sm-${partSizes.content}`, 'part', 'content-part']"
      >
        <div class="hidden-sm-and-up context-action-panel">
          <slot name="contextActionPanel"/>
        </div>
        <div class="content-body">
          <slot name="contentPart"/>
        </div>
      </v-col>
      <v-col
        :class="['hidden-xs-only', `col-sm-${partSizes.context}`, 'part', 'right-part', 'pb-0 pt-0 pl-0']"
      >
        <div class="context-action-panel">
          <slot name="contextActionPanel"/>
        </div>
        <div class="context-part" v-sticky="{ zIndex: 1, stickyTop: 140,disabled: false}">
          <div>
            <slot name="contextPart"/>
          </div>
        </div>
        <div v-if="isContextFooter" class="context-footer" :class="{'context-footer--detail': !this.isOverview}">
          <slot name="contextFooter"></slot>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'ContainerLayout',
  components: {},
  props: {
    isOverview: Boolean
  },
  data () {
    return {}
  },
  computed: {
    partSizes () {
      return {
        content: (this.isOverview ? '8' : '7'),
        context: (this.isOverview ? '4' : '5')
      }
    },
    isContextFooter () {
      return !!this.$slots.contextFooter
    }
  },
  methods: {},
  created () {}
}
</script>

<style lang="scss" scoped>
  .container-layout {
    // padding: 0 1em;
    .part {
      // padding: 0 1em;
      -webkit-transition: .2s cubic-bezier(.4,0,.2,1);
      transition: .2s cubic-bezier(.4,0,.2,1);
    }
    .content-part {
      padding: 0 0 0 1em;
      border-right: 1px solid rgba(0, 0, 0, 0.12);
    }

    .right-part {
      position: relative;
      // max-height: calc(100vh - 64px);
    }

    .context-part {
      padding: 0 1em;
      position: relative;
      padding-bottom: 54px;
      max-width: 100%;
    }
    .context-footer {
      position: fixed;
      top: calc(100vh - 55px);
      left: 66.66%;
      width: 100%;
      height: 55px;
      z-index: 4;

      -webkit-transition: .2s cubic-bezier(.4,0,.2,1);
      transition: .2s cubic-bezier(.4,0,.2,1);

      &.context-footer--detail {
        left: 58.33%;
      }
    }

    .context-action-panel {
      height: 70px;
      position: sticky;
      z-index: 2;
      top: 64px;
      left: 0;
      width: 100%;
      padding: 0 1em;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      background-color: #fafafa;

    }

    @media only screen and (max-width : 599px){
      .content-body {
        margin-top: 60px;
      }
      .context-action-panel {
        height: 60px;
      }
    }

  }
</style>
